export default __webpack_public_path__ + "static/media/Mobile Screenshot 4.0b2ea4e4.png";